import { useQuery } from "@tanstack/react-query";

import { getAgentStatus } from "@/api/agent";

const terminalStatuses = new Set(["completed", "failed", "cancelled"]);

export function useAgentSSE(sessionId: string | null) {
  return useQuery({
    queryKey: ["agent", "status", sessionId],
    queryFn: () => getAgentStatus(sessionId ?? ""),
    enabled: Boolean(sessionId),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status && terminalStatuses.has(status) ? false : 1500;
    },
    refetchIntervalInBackground: true,
  });
}
